<template>
  <div>
    <div class="page-actions">
      <span>币种： </span>
      <el-select v-model="coinType" placeholder="请选择币种">
        <el-option
          v-for="item in coinList"
          :key="item"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <span>是否排除机器人：</span>
      <el-switch v-model="exclude"></el-switch>
      <span>时间：</span>
      <el-date-picker
        v-model="date"
        type="date"
        placeholder="选择日期"
        format="yyyy 年 MM 月 dd 日"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      <el-input
        v-model="keywords"
        placeholder="关键词：如ID，电话，邮箱"
      ></el-input>
      <el-button type="primary" @click="search({ page: 1 })">搜索</el-button>
      <a :href="downloadLink" target="_blank">导出Excel</a>
      <a :href="downloadLinks" target="_blank">导出所有Excel</a>
    </div>
    <div class="counts">
      <span>总数：</span>
      <span>{{ totalCount }}</span>
      <span>{{ amoutASum }}</span>
      <span>{{ frozeSum }}</span>
      <span>{{ minAmountSum }}</span>
      <span>{{ minFrozeSum }}</span>
    </div>
    <el-table :data="currencies">
      <el-table-column prop="coinType" label="币种"></el-table-column>
      <el-table-column prop="userId" label="用户ID"></el-table-column>
      <el-table-column prop="coinAmount" label="账户资产"></el-table-column>
      <el-table-column prop="coinFroze" label="冻结资产"></el-table-column>
      <el-table-column prop="minCoinAmount" label="最小余额"></el-table-column>
      <el-table-column
        prop="minCoinFroze"
        label="最小冻结余额"
      ></el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :total="totalCount"
      :page="pagination.page"
      @pageChanged="pageChanged"
    ></pagination>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex';
import qs from 'qs';
import Pagination from 'components/pagination';

export default {
  name: 'assets',
  data() {
    return {
      date: '',
      coinType: '',
      keywords: '',
      exclude: false
    };
  },

  computed: {
    ...mapState('snapshoot', [
      'currencies',
      'pagination',
      'totalCount',
      'coinList',
      'totalCount',
      'frozeSum',
      'minAmountSum',
      'minFrozeSum',
      'amoutASum'
    ]),
    downloadLink() {
      const data = {
        date: this.date,
        keywords: this.keywords,
        coinType: this.coinType,
        ...this.pagination
      };
      const params = qs.stringify(data);
      return `/la/admin/snapshoot/export?${params}`;
    },
    downloadLinks() {
      const data = {
        coinType: this.coinType
      };
      const params = qs.stringify(data);
      return `/la/admin/produce/excel/day?${params}`;
    }
  },
  methods: {
    ...mapActions('snapshoot', ['list']),
    ...mapMutations('snapshoot', ['setpage']),
    search(data) {
      if (!this.date) {
        this.$message({
          message: '时间不能为空！',
          type: 'error'
        });
        return;
      }
      this.list({
        keywords: this.keywords,
        date: this.date,
        coinType: this.coinType,
        exclude: this.exclude,
        ...this.pagination,
        ...data
      });
    },
    pageChanged(pagination) {
      this.setpage(pagination);
      this.$emit('refresh', {
        pagination,
        coinType: this.coinType,
        exclude: this.exclude,
        date: this.date,
        keywords: this.keywords
      });
    }
  },
  components: {
    Pagination
  },
  created() {}
};
</script>

<style lang="less" scoped>
.el-table {
  ::v-deep.cell {
    text-align: center;
  }
}
.counts {
  display: flex;
  border: 1px solid #ddd;
  span {
    width: 16.6%;
    line-height: 45px;
    border-right: 1px solid #ddd;
    text-align: center;
  }
}
</style>
